var _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _path5, _rect4, _rect5, _rect6, _circle, _circle2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 84,
    viewBox: "0 0 76 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0309 37.2777C25.3017 36.8631 21.3637 45.2734 21.3637 45.2734L20.3954 46.9362L19.5908 45.2734C19.5908 45.2734 23.804 35.1885 29.0309 35.6061C31.3482 35.7912 34.3946 38.1397 34.3946 38.1397V39.6416L32.9763 39.1393C32.9763 39.1393 30.4472 37.4352 29.0309 37.2777Z",
    fill: "#C6D3EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.265 35.1059C51.237 35.1059 55.6567 37.7306 58.24 40.2917C60.8234 42.8527 62.6237 47.2031 62.6723 50.8405C62.6299 51.1213 62.6741 52.2267 62.6723 52.5107V54.2533L65.8635 55.1841C67.9467 56.4694 69.365 57.5775 71.0936 60.3698C72.2903 63.8713 72.0777 65.7255 71.7141 67.8797C71.3506 70.034 69.664 73.0151 67.991 74.4201C66.3181 75.8252 62.2629 77.4481 60.0782 77.4341H13.853C11.5482 77.2391 7.97809 77.1238 5.23008 73.711C3.65825 72.0141 1.19671 68.6139 1.99452 64.3146C3.06937 58.5223 4.52735 58.4126 6.07221 56.691C7.61707 54.9695 10.9067 53.9084 13.2082 53.6771H14.9367H15.9562L17.2859 50.8405C17.9047 49.0345 19.8635 47.6189 21.4079 46.4968C22.9522 45.3747 25.7972 44.6658 27.706 44.6353C29.6147 44.6047 31.3361 44.6353 31.3361 44.6353C31.3361 44.6353 33.7847 40.2114 37.364 37.9425C40.0771 36.2228 43.7992 35.1052 46.265 35.1059ZM46.265 33.2624C42.9892 33.2689 39.7746 34.1511 36.9543 35.8176C34.134 37.4841 31.8106 39.8744 30.2247 42.7407C29.3935 42.5893 28.5508 42.5095 27.706 42.5021C24.8386 42.5017 22.0425 43.3953 19.7069 45.0585C17.3712 46.7218 15.6123 49.0719 14.6749 51.7816C14.3965 51.7816 14.1314 51.7021 13.853 51.7021C10.1789 51.7021 6.65538 53.1616 4.05745 55.7595C1.45951 58.3575 0 61.881 0 65.5551C0 69.2291 1.45951 72.7527 4.05745 75.3506C6.65538 77.9485 10.1789 79.4081 13.853 79.4081H60.0782C63.3512 79.4141 66.5201 78.2589 69.0214 76.1479C71.5226 74.037 73.1939 71.1072 73.7379 67.8797C74.2819 64.6523 73.6634 61.3365 71.9923 58.5223C70.3212 55.7081 67.706 53.5779 64.6119 52.5107C64.6119 52.2323 64.7047 51.9805 64.7047 51.7021C64.6942 46.8148 62.7481 42.1307 59.2922 38.6748C55.8364 35.219 51.1523 33.2729 46.265 33.2624Z",
    fill: "#C6D3EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3792 24.4345C41.8718 24.4345 43.0831 22.5741 43.0831 21.0815V15.7277L34.4305 24.4345H40.3792ZM37.7187 29.211C37.7187 29.6428 38.1176 32.3747 38.6495 35.815C40.851 35.5931 44.8686 33.1331 48.3118 33.6876C53.1181 34.4615 57.2676 38.3858 57.8856 38.3858L62.5394 45.2558L63.9578 53.1452L65.445 54.6079C65.445 54.6079 65.445 52.3178 65.445 50.8252V18.3776C65.445 16.885 63.5035 14.9435 62.0109 14.9435H45.0571C45.0571 18.1883 45.0571 21.0815 45.0571 21.0815C45.0571 24.0681 43.3657 26.4084 40.3792 26.4084H34.2141V28.2096L37.7187 29.211ZM43.0831 12.9696V13.0075C43.2562 13.0075 43.9782 12.9412 45.7871 12.9696H62.0109C64.9975 12.9696 67.4189 15.391 67.4189 18.3776V50.8252C67.4189 56.3808 68.4315 54.6079 65.445 54.6079L63.9578 53.1452L62.5394 45.2558L57.8856 38.3858C56.6616 38.3858 53.3185 34.4661 48.3118 33.6876C45.3559 33.2279 40.6075 35.6176 38.6495 35.815C38.162 32.4465 37.7187 30.251 37.7187 29.211L32.2673 28.2096L32.2673 26.4895V23.7855L43.0831 12.9696Z",
    fill: "#C6D3EC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.769,
    y: 19.7259,
    width: 9.92829,
    height: 1.97059,
    rx: 0.985294,
    fill: "#C6D3EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5806,
    y: 31.959,
    width: 6.11653,
    height: 1.9502,
    rx: 0.9751,
    fill: "#C6D3EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.769,
    y: 25.8425,
    width: 9.92829,
    height: 1.97059,
    rx: 0.985294,
    fill: "#C6D3EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2301 20.1929C30.6355 19.6904 31.1497 17.5308 30.6472 16.1253L28.8444 11.0841L23.6287 22.196L29.2301 20.1929ZM26.0618 29.6723C35.5468 29.6716 33.1091 25.2663 33.1091 25.2663C39.0746 18.2633 42.8601 14.6288 42.8601 14.6288C43.4362 13.2368 54.6942 14.2945 54.6942 14.2945L50.7927 6.04973C50.2902 4.64429 47.8084 3.46993 46.4029 3.97251L30.439 9.68112C31.5316 12.7364 32.5058 15.4607 32.5058 15.4607C33.5114 18.2728 32.7068 21.046 29.8947 22.0516L24.0897 24.1274L26.0618 29.6723ZM27.9158 8.48714L27.9285 8.52278C28.0915 8.46451 28.749 8.15904 30.4618 7.57667L45.7383 2.11388C48.5504 1.10828 51.6458 2.57295 52.6514 5.38509L56.7331 14.2742C56.7331 14.2742 43.259 13.0152 42.8601 14.6288C42.8601 14.6288 39.2256 18.086 33.1091 25.2663C33.1091 25.2663 36.3446 29.6723 24.0897 29.6716L22.2838 24.8594L21.3733 22.3133L27.9158 8.48714Z",
    fill: "#C6D3EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3611 43.5272C22.2943 42.0202 18.077 46.3831 15.5573 51.9485C12.9928 52.8107 11.2793 53.4093 10.1518 53.8223C8.63857 54.3765 8.6735 53.4835 8.6735 51.872L8.6735 31.1575C8.6735 29.2393 10.2352 27.6878 12.1533 27.7004L36.0103 27.8565C37.9196 27.869 39.4573 29.4258 39.4448 31.3351C39.44 32.0611 39.4346 32.8857 39.4287 33.7934C39.4203 35.0843 38.6429 36.2459 37.4527 36.7458L37.4527 33.3091C37.4527 31.4266 35.9465 29.8901 34.0643 29.8526L14.2521 29.4584C12.3162 29.4198 10.7261 30.9786 10.7261 32.9148L10.7261 50.8808C10.7261 52.4297 10.7194 53.4455 12.1981 52.9845C12.9911 52.7373 14.079 52.4014 15.5573 51.9485C18.0683 46.4021 22.25 42.0119 30.3611 43.5272Z",
    fill: "#C6D3EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5586,
    y: 9.7799,
    width: 4.85888,
    height: 1.9502,
    rx: 0.9751,
    transform: "rotate(-88.784 63.5586 9.7799)",
    fill: "#C6D3EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2571,
    y: 10.6894,
    width: 5.96392,
    height: 1.9502,
    rx: 0.9751,
    transform: "rotate(-42.6669 68.2571 10.6894)",
    fill: "#C6D3EC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6667,
    y: 15.1,
    width: 5.33351,
    height: 1.9502,
    rx: 0.9751,
    transform: "rotate(0.478526 70.6667 15.1)",
    fill: "#C6D3EC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0551,
    cy: 35.3377,
    r: 2.04904,
    fill: "#C6D3EC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2331,
    cy: 67.8049,
    r: 15.5041,
    fill: "#0078FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4983 66.2719L26.2366 68.0857M26.2366 68.0857L28.0509 66.3469M26.2366 68.0857C26.3298 63.6711 29.7274 59.7183 34.142 59.8115C38.5566 59.9047 42.0598 63.5589 41.9666 67.9735C41.8733 72.3881 38.2191 75.8912 33.8045 75.798C30.872 75.7361 28.3416 74.1028 27.0005 71.719M36.3029 69.7279L33.8045 68.4516L33.8045 63.1863",
    stroke: "#F5F5F5",
    strokeWidth: 1.77291,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0303985012b2ab5390b55040f908be3c.svg";
export { ForwardRef as ReactComponent };